
import React from 'react'

import { composeClassName } from '../../utils/common'
import MessageIndicators from '../MessageIndicators'
import { MessageProps } from '../../../MessageDisplayArea'
import MessageTime from '../MessageTime'
import Spinner from '../Spinner'

const VisitorMessage: React.FC<MessageProps> = props => {
  const {
    message: {
      nickname,
      renderText,
      type,
      isFirstInGroup,
      isLastInGroup,
    }
  } = props;

  return (
    <div className={composeClassName(type!, isFirstInGroup, isLastInGroup)}>
      {
        isFirstInGroup
        && (
          <>
            <p className="author">
              {nickname}
            </p>
            <MessageTime {...props} />
          </>
        )
      }

      <span className="message-text-wrapper">
        <div className="message-text">
          {renderText('span')}
          {<MessageIndicators {...props} />}
        </div>

        { <Spinner {...props}/> }
      </span>
    </div>
  );
};

export default VisitorMessage
